<template>
	<div class="mobile-navigation">
		<nav class="mobile-navigation__nav">
			<template v-for="item in navItemsMain">
				<router-link
					v-if="!mixinIsExternalLink(item.url)"
					:key="item.label"
					class="mobile-navigation__item"
					:to="item.url"
					exact-active-class="is-active"
				>
					<span class="mobile-navigation__item-text">{{ item.label }}</span>
					<Icon
						icon-name="right-arrow"
						size="sm"
						class="mobile-navigation__item-icon"
					/>
				</router-link>
				<a
					v-else
					:key="item.label"
					class="mobile-navigation__item"
					:href="item.urlExternal || item.url"
					target="_blank"
					rel="noopener noreferrer"
				>
					<span class="mobile-navigation__item-text">{{ item.label }}</span>
					<Icon
						icon-name="right-arrow"
						size="sm"
						class="mobile-navigation__item-icon"
					/>
				</a>
			</template>
			<div
				class="mobile-navigation__item -danger"
				@click="handleLogout"
			>
				<span class="mobile-navigation__item-text">{{ $Helpers.ucfirst($I18n.trans('commons.logout')) }}</span>
			</div>
		</nav>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';
import { mapActions, mapGetters } from 'vuex';
import laroute from '@laroute';

export default {
	name:       'MobileFanAccountNavigation',
	components: {
		Icon,
	},
	computed: {
		...mapGetters({
			isMobileViewport: 'device/isMobileViewport',
			profileUrl:       'user/profileUrl',
			profile:          'user/profile',
		}),
		navItemsMain() {
			const items = [
				{
					label:       this.$I18n.trans('arena.fan_account.my_account'),
					url:         this.profileUrl + '/profile',
					urlExternal: this.profileUrl,
					active:      false,
				},
			];

			if (this.$arenaConfig.paymentsEnabled && !this.profile?.externalProfileUrl) {
				items.push({
					label:  this.$I18n.trans('arena.fan_account.purchases.nav_label'),
					url:    `${laroute.route('arena.fan_account')}/purchases`,
					active: false,
				});
			}

			if (this.$arenaConfig.followingEnabled) {
				items.push({
					label:  this.$I18n.trans('arena.fan_account.following.nav_label'),
					url:    `${laroute.route('arena.fan_account')}/following`,
					active: false,
				});
			}

			return items;
		},
	},
	watch: {
		isMobileViewport: {
			handler() {
				this.handleRedirect();
			},
		},
	},
	mounted() {
		this.handleRedirect();
	},
	methods: {
		...mapActions({
			logout: 'user/logout',
		}),
		handleRedirect() {
			if (this.isMobileViewport === false) {
				this.$router.push('/account/profile');
			}
		},
		handleLogout() {
			this.logout();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

// .mobile-navigation {}

.mobile-navigation__nav {
	display: flex;
	flex-direction: column;
}

.mobile-navigation__item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: $sp4 0;

	&.-danger {
		color: var(--color-red);
	}

	&:not(:last-child) {
		border-bottom: 1px solid var(--color-grey-900);
	}
}

.mobile-navigation__item-text {
	@include font-size(fs-120);
}
</style>
